import Entity from "../../engine/entity";

export default class Explosion extends Entity{
    constructor({engine, position, size}){
        super({engine,type:"fx"});
        this.position = {...position};
        this.score = score || 0;
        this.size = size || 100;
        this.explosionScale = 0;
        this.lifetime = 0.1;
    }

    update(){
        this.explosionScale += this.engine.time.delta;
        this.lifetime -= this.engine.time.delta;
        if(this.lifetime <= 0){
            this.engine.destroyEntity(this);
        }
    }

    render(ctx){
        const s = this.engine.scaleFactor;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.shadowColor = "yellow";
        ctx.shadowBlur = this.size * 0.5 * s;
        ctx.fillStyle = "yellow";

        ctx.beginPath();
        ctx.arc( 0, 0, this.explosionScale * this.size * s, 2 * Math.PI, false);
        ctx.fill();
        ctx.fill();
        ctx.fill();

        ctx.restore();
    }
}